import api from "../../utils/apiPublic";

export async function getContenidoLegalPublicoBySlug(slug) {
  const encoded = encodeURIComponent(String(slug || "").trim());
  const res = await api.get(`/api/public/legales/${encoded}`);
  return res.data?.data ?? null;
}
